import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Loader from 'kepler/lib/components/Loader';
import Page from '../../lib/page';
import ContactOption from '../../contactUs/components/ContactOption';
import { callUsFromComplaintsPage, loadModalContainer } from '../../contactUs/actions/action-login-modal';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import BrexitComponent from '../components/BrexitComponent';
import { getComplaintsPageInfo } from '../../lib/globalHelper';
import { ARTICLE_LIST } from '../constants/PropTypesShapes';

const complaintsTextInfo = getComplaintsPageInfo();

class BrexitComplaintsContainer extends Component {
  static goToArticlePage(currentArticle) {
    trackLink({ id: 'complaintsPage', link: 'smarthelp-complaints-page', hpid: currentArticle.articleId });
  }

  static handleKeyPress(event, article) {
    if (event.which === 13) {
      BrexitComplaintsContainer.goToArticlePage(article);
    }
  }

  // Common function to get parsed article item.
  static getParsedFaqs(article) {
    return (
      <li key={article.articleId} className="brexit-complaints-page-div__common-div__common-questions-list">
        <a
          className="popular-item"
          href={Page.getFullArticleURL(article)}
          onClick={() => BrexitComplaintsContainer.goToArticlePage(article)}
          onKeyPress={(event) => BrexitComplaintsContainer.handleKeyPress(event, article)}
        >
          {article.articleTitle}
        </a>
      </li>
    );
  }

  static disputeLinkClick() {
    trackLink({ id: 'complaintsPage', link: 'smarthelp-complaints-page-dispute-link-clicked' });
  }

  static financialLinkClick() {
    trackLink({ id: 'complaintsPage', link: 'smarthelp-complaints-page-financial-link-clicked' });
  }

  static complaintsLinkClick() {
    trackLink({ id: 'complaintsPage', link: 'smarthelp-complaints-page-complaints-link-clicked' });
  }

  componentDidMount() {
    // Impression  event for complains page
    trackPage({ id: 'complaintsPage', link: 'smarthelp-complaints-page' });
  }

  // Contact channel click action
  getChannelAction(channel) {
    trackLink({ id: 'complaintsPage', link: `smarthelp-complaints-page-${channel}-click` });
    if (channel === 'email') {
      // for email click redirect to smc compose page
      return window.open('/smc/compose?ref_id=formal_complaints_l1', '_self');
    }

    if (!Page.isLoggedIn()) {
      // open the modal when clicked on callus in loggedout scenario
      return this.props.loadModalContainer(channel, '', true);
    }

    // updating modal state with request from complaints page
    this.props.callUsFromComplaintsPage();

    //  Redirect to contact-us page when clicked on callus in loggedin and updated callus location in action-contact-us
    return window.open('/smarthelp/contact-us', '_self');
  }

  // See a summary of our complaints data.
  /**
   * Complaints Page html content
   */
  complaintsPage() {
    return (
      <BrexitComponent
        renderCommonQuestions={this.renderCommonQuestions()}
        renderContactChannels={this.renderContactChannels()}
        disputeLinkClick={() => BrexitComplaintsContainer.disputeLinkClick()}
        financialLinkClick={() => BrexitComplaintsContainer.financialLinkClick()}
        complaintsLinkClick={() => BrexitComplaintsContainer.complaintsLinkClick()}
      />
    );
  }

  renderCommonQuestions() {
    const { articles } = this.props;

    if (articles && articles.length > 0) {
      // Impression for common questions
      trackPage({ id: 'complaintsPage', link: 'smarthelp-complaints-page-common-questions-displayed' });
      const articleMapping = articles.map((article) => BrexitComplaintsContainer.getParsedFaqs(article));
      return (
        <div className="brexit-complaints-page-div__common-div">
          <h3 className="brexit-complaints-page-div__common-div__common-question-header">{complaintsTextInfo.commonQuestionsHeader}</h3>
          {articleMapping}
        </div>
      );
    }

    return <div />;
  }

  // Displaying hardcoded channels for complaints page
  renderContactChannels() {
    return (
      <div className="brexit-complaints-page-div__contact-channels">
        <h3 className="brexit-complaints-page-div__contact-channels__channels-header">{complaintsTextInfo.channelsText}</h3>
        <div className="brexit-complaints-page-div__contact-channels__icons">
          <ContactOption
            key="email"
            id="contact-email-option"
            contactLinkCSS="btn vx_btn-link contact-link"
            iconClass="brexit-complaints-page-div__contact-channels__icons__icon-emailus"
            text="Email Us"
            supportMessageCSS="support-message"
            clickAction={() => { this.getChannelAction('email'); }}
            message=""
          />
        </div>
      </div>
    );
  }

  render() {
    // Checking whether common questions API is loaded or not
    if (this.props.commonQuestionsLoaded) {
      return <Loader show type="fixed" />;
    }

    return this.complaintsPage();
  }
}

BrexitComplaintsContainer.propTypes = {
  callUsFromComplaintsPage: PropTypes.func.isRequired,
  loadModalContainer: PropTypes.func.isRequired,
  articles: PropTypes.arrayOf(PropTypes.shape(ARTICLE_LIST)),
  commonQuestionsLoaded: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    articles: state.contactReason.complaintsPageFaqs,
    commonQuestionsLoaded: state.contactReason.isLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loadModalContainer, callUsFromComplaintsPage }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BrexitComplaintsContainer);
